/**
 * Environment Configuration
 * 
 * Centralizes all environment variables and provides type-safe access
 * with sensible defaults for development.
 */

export interface Environment {
  // API Configuration
  apiBaseUrl: string;
  wsBaseUrl: string;
  
  // Authentication
  authIssuer: string;
  authClientId: string;
  
  // Environment
  environment: 'development' | 'staging' | 'production';
  
  // Feature Flags
  enableBackendIntegration: boolean;
  enableWebsockets: boolean;
  enableFileUpload: boolean;
  
  // Development
  debugApi: boolean;
  mockDelayMs: number;
}

// Get environment with defaults
export const environment: Environment = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://ma3yuktnyh.execute-api.us-east-1.amazonaws.com',
  wsBaseUrl: import.meta.env.VITE_WS_BASE_URL || 'wss://ma3yuktnyh.execute-api.us-east-1.amazonaws.com',
  
  authIssuer: import.meta.env.VITE_AUTH_ISSUER || '',
  authClientId: import.meta.env.VITE_AUTH_CLIENT_ID || '140b21t9d60d37mbk83sq2cgsr',
  
  environment: (import.meta.env.VITE_ENVIRONMENT as any) || 'development',
  
  enableBackendIntegration: import.meta.env.VITE_ENABLE_BACKEND_INTEGRATION === 'true',
  enableWebsockets: import.meta.env.VITE_ENABLE_WEBSOCKETS === 'true',
  enableFileUpload: import.meta.env.VITE_ENABLE_FILE_UPLOAD === 'true',
  
  debugApi: import.meta.env.VITE_DEBUG_API === 'true',
  mockDelayMs: parseInt(import.meta.env.VITE_MOCK_DELAY_MS || '1000'),
};

// Validation
if (environment.enableBackendIntegration && !environment.apiBaseUrl) {
  console.warn('Backend integration enabled but VITE_API_BASE_URL not set');
}

if (environment.enableWebsockets && !environment.wsBaseUrl) {
  console.warn('WebSockets enabled but VITE_WS_BASE_URL not set');
}

export default environment;
